import React, { useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Divider, Drawer, Table } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';

// Constants & Helpers
import { toISTDate } from '@Apis/constants';
import Helpers from '@Apis/helpers';

// UI Components
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Modal from '@Uilib/H3Modal';
import PRZText from '../../../Common/UI/PRZText';

// Common Components
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';

// Module-Specific Components
import ViewGRN from '../../../Purchase/GoodsReceiving/GoodsReceivingHome/ViewGRN';

// Assets
import closeIcon from '@Images/icons/icon-close-blue.png';

// Actions
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import UserActions from '@Actions/userActions';

// Styles
import './style.scss';


const PendingGoodReceivingList = ({
  user,
  MONEY,
  getPendingActions,
  getPendingActionsLoading,
  pendingActions,
  priceMasking,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showSoModal, setShowSoModal] = useState(false);
  const [selectedGRN, setSelectedGRN] = useState(null);
  const [selectedGRNForMobile, setSelectedGRNForMobile] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const history = useHistory();

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const ListScreenKeys = ({ documentData, isDataMaskingPolicyEnable, isHideCostPrice, }) => {
    const record = documentData;

    return [
      {
        label: 'GRN #',
        value: record?.grn_number,
      },
      {
        label: 'BUSINESS UNIT',
        value: record?.tenant_info?.tenant_name,
      },
      {
        label: 'VENDOR',
        value: `${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ''}${record?.seller_info?.seller_name}`?.trim(),
      },
      {
        label: 'VENDOR INVOICE #',
        value: record?.invoice_number || '-',
      },
      {
        label: 'REFERENCE#',
        value: record?.grn_entity_type === 'PURCHASE_ORDER' ? `${record?.grn_entity_details?.po_number || '-'}` : `${record?.grn_entity_details?.stock_transfer_number || '-'}`,
      },
      {
        label: 'CREATED TIME',
        value: `${toISTDate(record?.order_date).format('DD/MM/YYYY')} by ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'}`,
      },
      {
        label: 'GRN DATE',
        value: toISTDate(record?.grn_date_time).format('DD/MM/YYYY'),
      },
      {
        label: 'GRAND TOTAL',
        value: (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view grand total" /> : MONEY((record?.document_grn_grand_total || record?.grn_grand_total || '0'), record?.org_currency_info?.currency_code),
      },
      {
        label: 'DUE DATE',
        value: record?.grn_due_date ? dayjs(record?.grn_due_date).format('DD/MM/YYYY') : '-',
      }
    ];
  };

  const tableColumns = [
    {
      title: '',
      render: (record) => (
        <div onClick={() => {
          // this.setState({ selectedGRN: record });
        }}
        >
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText text={`#${record?.grn_number}`} className="mobile-list__card_item-number" />
              </div>
              <div className="mobile-list__card_header-right">
                <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
                  {Helpers.getStatusColor(record.status).text?.toUpperCase()}
                </div>
              </div>
            </div>
            <div className="mobile-list__item-info">
              {`Business Unit - ${record.tenant_info?.tenant_name}`}
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-details">
                  {`VENDOR - ${`${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ''}${record?.seller_info?.seller_name}`?.trim()}`}
                </div>
                <div className="mobile-list__card_item-details">
                  {`VENDOR INVOICE # - ${record?.invoice_number || '-'}`}
                </div>
                <PRZText text={`DUE DATE - ${record?.grn_due_date ? dayjs(record?.grn_due_date).format('DD/MM/YYYY') : '-'}`} className="mobile-list__card_item-details" />
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedGRNForMobile(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
          <Drawer
            open={moreDetailsDrawer}
            width="420px"
            mask
            onClose={() => setMoreDetailsDrawer(false)}
            destroyOnClose
          >
            <div className="custom-drawer__header-wrapper">
              <div
                className="custom-drawer__header"
                style={{ width: '370px' }}
              >
                <H3Text
                  text={`${selectedGRNForMobile?.grn_number}`}
                  className="custom-drawer__title"
                />
                <H3Image
                  src={closeIcon}
                  className="custom-drawer__close-icon"
                  onClick={() => setMoreDetailsDrawer(false)}
                />
              </div>
            </div>
            <MoreInfoMobileView
              description={selectedGRNForMobile?.description}
              customFields={selectedGRNForMobile?.custom_fields}
              fields={ListScreenKeys({ documentData: selectedGRNForMobile, isDataMaskingPolicyEnable: isDataMaskingPolicyEnable, isHideCostPrice: isHideCostPrice, })}
            />
          </Drawer>
        </div>
      ),
      responsive: ['xs'],
    },
    {
      title: 'GRN #',
      render: (text, record) => (
        <div className="column-number__wrapper">
          <H3Text text={record?.grn_number} />
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'BUSINESS UNIT',
      render: (text, record) => (
        <div>
          <H3Text text={record?.tenant_info?.tenant_name} />
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'VENDOR',
      render: (text, record) => (
        <React.Fragment>
          {record?.seller_info?.seller_name ? (
            <div
              className="associated-entity"
              onClick={() => history.push(`/vendors/view/${record?.seller_id}`)}
            >
              {`${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ''}${record?.seller_info?.seller_name}`?.trim()}

            </div>
          ) : '-'}
        </React.Fragment>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'VENDOR INVOICE #',
      render: (text, record) => (
        <div className="vendor-invoice">
          {record?.invoice_number || '-'}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'REFERENCE#',
      render: (text, record) => (
        <div className="associated-entity">
          <Link
            to={record?.grn_entity_type === 'PURCHASE_ORDER' ? `/approval?type=po&id=${record?.grn_entity_id}` : `/purchase/goods-receiving/view/${record?.grn_id}/type=st`}
            target="_blank"
          >
            <H3Text
              text={(
                <div>
                  {record?.grn_entity_type === 'PURCHASE_ORDER' ? `${record?.grn_entity_details?.po_number || '-'}` : `${record?.grn_entity_details?.stock_transfer_number || '-'}`}
                  <div className="" />
                </div>
              )}
            />
          </Link>
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'CREATED TIME',
      render: (record) => (
        <div>
          <div className="column-date">
            {toISTDate(record?.order_date).format('DD/MM/YYYY')}
          </div>
          <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'GRN DATE',
      render: (record) => (
        <div className="column-date">
          {toISTDate(record?.grn_date_time).format('DD/MM/YYYY')}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'GRAND TOTAL',
      render: (item, record) => (
        <div className="column-amount">
          {record?.allow_grn_to_create_ap_invoice ? '-' : (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view grand total"} /> : MONEY((record?.document_grn_grand_total || record?.grn_grand_total || '0'), record?.org_currency_info?.currency_code)}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'DUE DATE',
      render: (text, record) => (
        <div className="column-date">
          {record?.grn_due_date ? <H3Text text={dayjs(record?.grn_due_date).format('DD/MM/YYYY')} /> : '-'}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: '',
      key: 'action',
      fixed: 'right',
      render: (record) => (
        <div className="list__actions">
          <div className="list__actions-button list__actions-button-dark" onClick={() => { setSelectedGRN(record); setShowSoModal(true); }}>
            View
          </div>
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      className: 'list__actions-column',
    },
  ];

  useEffect(() => {
    if (user) {
      getPendingActions('map_grn', 10, currentPage, () => { });
    }
  }, [user, getPendingActions, currentPage]);
  return (
    <React.Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list___table-header__left">
                      {`${Number(pendingActions?.grn_approval_count || 0)} Goods Receiving`}
                    </div>
                  </div>
                )}
                loading={getPendingActionsLoading}
                showHeader
                size="small"
                scroll="scroll"
                columns={tableColumns}
                rowKey="grn_id"
                dataSource={pendingActions?.good_receiving_note || []}
                pagination={(Number(pendingActions?.grn_approval_count) > 10) ? {
                  defaultCurrent: 1,
                  current: currentPage,
                  total: Number(pendingActions?.grn_approval_count),
                  pageSize: 10,
                  onChange: (page) => {
                    getPendingActions('map_grn', 10, page, () => { });
                    setCurrentPage(page);
                  },
                  position: ['bottomRight'],
                  showSizeChanger: false,
                } : false}
              />
            </div>
          </div>
        </div>
      </div>
      <H3Modal
        onClose={() => {
          getPendingActions('map_grn', 10, currentPage, () => { });
          setShowSoModal(false);
        }}
        className="pending-grn__view-grn"
        isOpen={showSoModal}
        title={`Good Receiving #${selectedGRN ? selectedGRN?.grn_number : ''} for ${selectedGRN?.tenant_info?.tenant_name}`}
        showHeader
      >
        <ViewGRN selectedGrnId={selectedGRN?.grn_id} selectedTenantId={selectedGRN?.tenant_info?.tenant_id} isQuickView />
      </H3Modal>
    </React.Fragment>
  );
};

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getPendingActions: (actionType, limit, page, callback) => dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
  getPurchaseRequestsSuccess: (purchaseRequests) => dispatch(PurchaseRequestActions.getPurchaseRequestsSuccess(purchaseRequests)),
});

PendingGoodReceivingList.propTypes = {
  user: PropTypes.any,
  getPendingActions: PropTypes.func,
  getPendingActionsLoading: PropTypes.bool,
  pendingActions: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingGoodReceivingList);
